import React from "react";
import PreloaderListItem from "../ListItem";

export default function PreloaderList({ itemCount }) {
  return (
    <div className="pre-list">
      {[...Array(itemCount)].map((_, index) => (
        <PreloaderListItem key={index} />
      ))}
    </div>
  );
}
